export default "__VITE_ASSET__czm6Q3ry__"